import React from 'react';
import { Alert } from 'react-bootstrap';

const StatusIndicator = ({ status }) => {
  const statusColorMap = {
    'success': 'success',
    'error': 'danger',
    'warning': 'warning',
    'info': 'info',
    'Invited': 'info',
    'Active': 'success',
    'Deactivation Requested': 'danger',
    'Deactivated': 'danger',
  };

  const alertVariant = statusColorMap[status] || 'primary';

  return (
    <Alert variant={alertVariant}>
      {status}
    </Alert>
  );
};

export default StatusIndicator;